/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getComment} from '../api'

 export const useQueryGetComment = createReactQueryHook('getComment', getComment)
